import NotificationAudio from 'assets/audios/notification.mp3';

const audio = new Audio(NotificationAudio);
class AudioService  {
  notification(){
    audio.currentTime = 0;
    audio.play().catch((error) => {
      // Autoplay policy: no user gesture in this document yet. Not actionable.
      console.debug('[audio] notification sound suppressed', error);
    });
  }
}

export default new AudioService();
